import React, { useState } from "react";
import { Container, Form, Button, Row, Col, Alert } from "react-bootstrap";
import { Mail, Phone, MapPin, Send, MessageSquare, User, CheckCircle, AlertCircle } from 'lucide-react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';

function ContactForm() {
  const [formData, setFormData] = useState({
    nombre: "",
    telefono: "",
    email: "",
    departamento: "",
    asunto: "",
    mensaje: "",
  });
  

  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [focusedField, setFocusedField] = useState(null);

  const navigate = useNavigate();
  
  const {
    nombre,
    telefono,
    email,
    departamento,
    asunto,
    mensaje
  } = formData;

  const onChange = e => setFormData({...formData, [e.target.name]: e.target.value});
  
  const onSubmit = e => {
    e.preventDefault();
    setLoading(true);
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const formDataToSend = new FormData();
    formDataToSend.append('nombre', nombre);
    formDataToSend.append('telefono', telefono);
    formDataToSend.append('email', email);
    formDataToSend.append('departamento', departamento);
    formDataToSend.append('asunto', asunto);
    formDataToSend.append('mensaje', mensaje);
    
    const fetchData = async() => {
      try {  
        //const res = await axios.post(`http://127.0.0.1:8000/api/contact/`, formDataToSend, config);
        const res = await axios.post(`/api/contact/`, formDataToSend, config)
        if(res.status === 200) {
          setMessage({ type: "success", text: "Mensaje enviado con éxito" });
          setFormData({
            nombre: '',
            telefono: '',
            email: '',
            departamento: '',
            asunto: '',
            mensaje: '',
          });
          setTimeout(() => {
            navigate('/thanks');
          }, 2000);
        } else {
          setMessage({ type: "danger", text: "Error al enviar el mensaje" });
        }
      } catch (error) {
        setMessage({ type: "danger", text: "Error al enviar el mensaje" });
      }
      setLoading(false);
    };
    fetchData();
  };


  const departamentos = [
    "Cochabamba", "Santa Cruz", "La Paz", "Sucre", 
    "Oruro", "Potosí", "Tarija", "Pando", "Beni"
  ];

  return (
    <section className="contact-form-section">
      {/* Fondo decorativo */}
      <div className="contact-background">
        <div className="contact-shape contact-shape-1"></div>
        <div className="contact-shape contact-shape-2"></div>
        <div className="contact-shape contact-shape-3"></div>
        <div className="contact-grid-pattern"></div>
      </div>

      <Container className="contact-container">
        {/* Header */}
        <div className="contact-header text-center">
          <div className="contact-badge">
            <MessageSquare size={20} />
            <span>Contáctanos</span>
          </div>
          <h2 className="contact-title">
            ¿Tienes alguna <span className="text-highlight-contact">Consulta?</span>
          </h2>
          <p className="contact-subtitle">
            Completa el formulario y nos pondremos en contacto contigo.
          </p>
          <div className="title-divider-contact"></div>
        </div>

        <Row className="g-5">
          {/* Columna del Formulario */}
          <Col lg={12}>
            <div className="form-card">
              <div className="form-card-header">
                <h3 className="form-card-title text-center">Envíanos un Mensaje</h3>
                <p className="form-card-subtitle text-center">
                  Completa el formulario y te responderemos a la brevedad
                </p>
              </div>

              {message && (
                <Alert 
                  variant={message.type} 
                  className={`custom-alert ${message.type}`}
                  dismissible
                  onClose={() => setMessage(null)}
                >
                  <div className="alert-content">
                    {message.type === "success" ? (
                      <CheckCircle size={24} />
                    ) : (
                      <AlertCircle size={24} />
                    )}
                    <span>{message.text}</span>
                  </div>
                </Alert>
              )}

              <Form onSubmit={e => onSubmit(e)} className="contact-form">
                {/* Nombre */}
                <Form.Group className="form-group-custom">
                  <div className="input-wrapper">
                    <div className={`input-icon ${focusedField === 'nombre' ? 'focused' : ''}`}>
                      <User size={20} />
                    </div>
                    <Form.Control
                      type="text"
                      name="nombre"
                      value={formData.nombre}
                      onChange={e => onChange(e)}
                      onFocus={() => setFocusedField('nombre')}
                      onBlur={() => setFocusedField(null)}
                      required
                      placeholder="Nombre completo"
                      className="form-input-custom"
                    />
                  </div>
                </Form.Group>

                <Row>
                  {/* Teléfono */}
                  <Col md={6}>
                    <Form.Group className="form-group-custom">
                      <div className="input-wrapper">
                        <div className={`input-icon ${focusedField === 'telefono' ? 'focused' : ''}`}>
                          <Phone size={20} />
                        </div>
                        <Form.Control
                          type="tel"
                          name="telefono"
                          value={formData.telefono}
                          onChange={e => onChange(e)}
                          onFocus={() => setFocusedField('telefono')}
                          onBlur={() => setFocusedField(null)}
                          pattern="[0-9]{7,15}"
                          required
                          placeholder="Teléfono"
                          className="form-input-custom"
                        />
                      </div>
                    </Form.Group>
                  </Col>

                  {/* Email */}
                  <Col md={6}>
                    <Form.Group className="form-group-custom">
                      <div className="input-wrapper">
                        <div className={`input-icon ${focusedField === 'email' ? 'focused' : ''}`}>
                          <Mail size={20} />
                        </div>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={e => onChange(e)}
                          onFocus={() => setFocusedField('email')}
                          onBlur={() => setFocusedField(null)}
                          required
                          placeholder="Correo electrónico"
                          className="form-input-custom"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  {/* Departamento */}
                  <Col md={6}>
                    <Form.Group className="form-group-custom">
                      <div className="input-wrapper">
                        <div className={`input-icon ${focusedField === 'departamento' ? 'focused' : ''}`}>
                          <MapPin size={20} />
                        </div>
                        <Form.Select
                          name="departamento"
                          value={formData.departamento}
                          onChange={e => onChange(e)}
                          onFocus={() => setFocusedField('departamento')}
                          onBlur={() => setFocusedField(null)}
                          required
                          className="form-input-custom form-select-custom"
                        >
                          <option value="">Seleccionar departamento</option>
                          {departamentos.map((dept, index) => (
                            <option key={index} value={dept}>{dept}</option>
                          ))}
                        </Form.Select>
                      </div>
                    </Form.Group>
                  </Col>

                  {/* Asunto */}
                  <Col md={6}>
                    <Form.Group className="form-group-custom">
                      <div className="input-wrapper">
                        <div className={`input-icon ${focusedField === 'asunto' ? 'focused' : ''}`}>
                          <Send size={20} />
                        </div>
                        <Form.Control
                          type="text"
                          name="asunto"
                          value={formData.asunto}
                          onChange={e => onChange(e)}
                          onFocus={() => setFocusedField('asunto')}
                          onBlur={() => setFocusedField(null)}
                          required
                          placeholder="Asunto"
                          className="form-input-custom"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Mensaje */}
                <Form.Group className="form-group-custom">
                  <div className="input-wrapper">
                    <div className={`input-icon textarea-icon ${focusedField === 'mensaje' ? 'focused' : ''}`}>
                      <MessageSquare size={20} />
                    </div>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="mensaje"
                      value={formData.mensaje}
                      onChange={e => onChange(e)}
                      onFocus={() => setFocusedField('mensaje')}
                      onBlur={() => setFocusedField(null)}
                      required
                      placeholder="Escribe tu mensaje aquí..."
                      className="form-input-custom form-textarea-custom"
                    />
                  </div>
                </Form.Group>

                {/* Botón Submit */}
                <div className="form-submit-wrapper">
                  <Button
                    type="submit"
                    disabled={loading}
                    className="btn-contact-submit"
                  >
                    {loading ? (
                      <>
                        <span className="spinner"></span>
                        <span>Enviando...</span>
                      </>
                    ) : (
                      <>
                        <span>Enviar Mensaje</span>
                        <Send size={20} />
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </div>
          </Col>

          {/* Columna de Información */}
          {/* <Col lg={5}>
            <div className="contact-info-section">
              <div className="info-header">
                <h3 className="info-title">Información de Contacto</h3>
                <p className="info-subtitle">
                  Otras formas de comunicarte con nosotros
                </p>
              </div>
              <div className="ubicacion-card contacto-card">
                                <div className="info-item">
                                    <div className="info-icon">
                                        <Phone size={20} />
                                    </div>
                                    <div className="info-content">
                                        <h4>Teléfono</h4>
                                        <p>{ubicacionInfo.telefono}</p>
                                    </div>
                                </div>

                                <div className="info-item">
                                    <div className="info-icon">
                                        <Mail size={20} />
                                    </div>
                                    <div className="info-content">
                                        <h4>Email</h4>
                                        <p>{ubicacionInfo.email}</p>
                                    </div>
                                </div>

                                <div className="info-item">
                                    <div className="info-icon">
                                        <Clock size={20} />
                                    </div>
                                    <div className="info-content">
                                        <h4>Horarios</h4>
                                        <p>{ubicacionInfo.horario.semana}</p>
                                        <p>{ubicacionInfo.horario.sabado}</p>
                                    </div>
                                </div>
                            </div> */}
              

              {/* CTA adicional */}
              {/* <div className="info-cta">
                <h4 className="info-cta-title">¿Prefieres visitarnos?</h4>
                <p className="info-cta-text">
                  Te esperamos en nuestras oficinas de lunes a sábado
                </p>
                <a href="/ubicacion" className="btn-info-cta">
                  <MapPin size={18} />
                  Ver Ubicación
                </a>
              </div> */}
            {/* </div>
          </Col> */}
        </Row>
      </Container>
    </section>
  );
}

export default ContactForm;